<template>
    <div>
        <v-container>
            <v-row justify="center" align="center">
                <v-col cols="3">
                    <z-source-selector @changevalue="handleQuery" :search="true" label="请选择部门"
                                       v-model="queryRequest.deptId"
                                       :source="'DeptSelector'"/>
                </v-col>
                <v-col cols="3">
                    <z-select-month @change="changeMonth"
                                    :allowed-dates="allowedDates"
                                    v-model="queryRequest.dateMonth"></z-select-month>
                </v-col>
                <!--<v-col cols="1">-->
                <!--<v-btn color="primary" @click=handleQuery>查询</v-btn>-->
                <!--</v-col>-->
                <v-col cols="1">
                    <v-btn color="primary"
                           @click=downLoadReport>月账单汇总下载
                    </v-btn>
                </v-col>
            </v-row>
        </v-container>

        <v-row justify="center">
            <v-col cols="10">
                <v-data-table
                        :headers="headers"
                        :items="list"
                        class="elevation-1"
                >
                    <template v-slot:item.actions="{item}">
                        <v-btn color="primary"
                               text
                               @click="downLoadOrder(item)">账单下载
                        </v-btn>
                    </template>
                </v-data-table>
            </v-col>
        </v-row>

        <z-loading v-model="isShowLoading"></z-loading>

    </div>
</template>

<script>

  import {
    deptMonthBill,
    deptMonthBillReport,
    deptMonthBillDetailReport,
  } from "@/api/billManagement"
  import downloadReportExcel from "@/utils/reportDownLoad"

  export default {
    name: "BillManagement",
    data() {
      return {
        isShowLoading: false,
        queryRequest: {
          deptId:'',
          dateMonth: ''
        },
        list: [],
        headers: [
          {text: '部门', align: 'start', sortable: false, value: 'deptName',},
          {text: '账单月份', value: 'billDateMonth'},
          {text: '月借用次数', value: 'monthBorrowCount'},
          {text: '月使用时间', value: 'monthUseTime'},
          {text: '费用合计', value: 'allCost'},
          {text: '操作', value: 'actions', align: 'center'},
        ],
      }
    },
    mounted() {
      var todayDate = new Date();
      var year = todayDate.getFullYear();
      var month = todayDate.getMonth() + 1;
      if (month < 10) {
        month = '0' + month;
      }
      this.queryRequest.dateMonth = year + '-' + month;
      this.handleQuery();
    },
    methods: {
      allowedDates(val) {
        return Date.parse(val) < Date.now()
      },
      handleQuery() {
        this.isShowLoading = true;
        if(this.queryRequest.deptId  == null){
          this.queryRequest.deptId = '';
        }
        deptMonthBill(this.queryRequest).then(res => {
          this.list = res;
          console.log(this.list, 'this.list');
          this.isShowLoading = false;
        }).catch(err => {
          this.isShowLoading = false;
        })
      },
      changeMonth(month) {
        this.queryRequest.dateMonth = month;
        this.handleQuery();
      },
      downLoadReport() {
        // 按月科室报表下载按钮
        this.isShowLoading=true;
        deptMonthBillReport(this.queryRequest).then(res => {
          console.log(res, "res");
          downloadReportExcel(res);
          this.isShowLoading=false;
        }).catch(err => {
          this.isShowLoading=false;
        });
      },
      downLoadOrder(item) {
        this.isShowLoading=true;
        var reqData={
          dateMonth:this.queryRequest.dateMonth,
          deptId:item.deptId
        };
        // 科室月账单下载
        deptMonthBillDetailReport(reqData).then(res => {
          downloadReportExcel(res);
          this.isShowLoading=false;
        }).catch(err => {
          this.isShowLoading=false;
        });
      },
    },
  }
</script>

<style scoped>

</style>

